<template>
  <v-card class="mb-3" outlined>
    <v-card-title class="pa-3 pb-0">
      <span class="text-h6">{{ product.id }}</span>
      <v-spacer></v-spacer>
      <v-chip small :color="product.type === 'single' ? 'primary' : 'success'" text-color="white">
        {{ product.type }}
      </v-chip>
    </v-card-title>
    
    <v-card-text class="pa-3">
      <v-row dense class="mb-2">
        <v-col cols="3">
          <div class="text-caption grey--text">가격</div>
          <div class="text-body-2 font-weight-medium">{{ product.price.toLocaleString() }}원</div>
        </v-col>
        <v-col cols="3">
          <div class="text-caption grey--text">최대 인원</div>
          <div class="text-body-2 font-weight-medium">{{ product.maxpersons }}명</div>
        </v-col>
        <v-col cols="3">
          <div class="text-caption grey--text">무료 보정</div>
          <div class="text-body-2 font-weight-medium">{{ product.freePicEditCount !== undefined ? product.freePicEditCount : 1 }}개</div>
        </v-col>
        <v-col cols="3">
          <div class="text-caption grey--text">순서</div>
          <div class="text-body-2 font-weight-medium">{{ product.order }}</div>
        </v-col>
      </v-row>
      
      <v-divider class="my-2"></v-divider>
      
      <v-list dense class="pa-0">
        <v-list-item class="px-0">
          <v-list-item-content class="py-1">
            <v-list-item-subtitle class="text-caption">제목 (한글)</v-list-item-subtitle>
            <v-list-item-title class="text-body-2">{{ product.title.kr || '(미입력)' }}</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        
        <v-list-item class="px-0">
          <v-list-item-content class="py-1">
            <v-list-item-subtitle class="text-caption">제목 (영어)</v-list-item-subtitle>
            <v-list-item-title class="text-body-2">{{ product.title.en || '(미입력)' }}</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        
        <v-list-item class="px-0">
          <v-list-item-content class="py-1">
            <v-list-item-subtitle class="text-caption">제목 (일본어)</v-list-item-subtitle>
            <v-list-item-title class="text-body-2">{{ product.title.jp || '(미입력)' }}</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        
        <v-list-item class="px-0">
          <v-list-item-content class="py-1">
            <v-list-item-subtitle class="text-caption">부제목 (한글)</v-list-item-subtitle>
            <v-list-item-title class="text-body-2">{{ product.subtitle.kr || '(미입력)' }}</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        
        <v-list-item class="px-0">
          <v-list-item-content class="py-1">
            <v-list-item-subtitle class="text-caption">부제목 (영어)</v-list-item-subtitle>
            <v-list-item-title class="text-body-2">{{ product.subtitle.en || '(미입력)' }}</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        
        <v-list-item class="px-0">
          <v-list-item-content class="py-1">
            <v-list-item-subtitle class="text-caption">부제목 (일본어)</v-list-item-subtitle>
            <v-list-item-title class="text-body-2">{{ product.subtitle.jp || '(미입력)' }}</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </v-list>
    </v-card-text>
    
    <v-card-actions class="pa-3 pt-0">
      <v-btn small color="primary" @click="$emit('edit')" class="mr-2">
        <v-icon small left>mdi-pencil</v-icon>
        편집
      </v-btn>
      <v-btn small color="error" outlined @click="$emit('delete')">
        <v-icon small left>mdi-delete</v-icon>
        삭제
      </v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
export default {
  name: 'ProductCard',
  props: {
    product: {
      type: Object,
      required: true
    }
  }
}
</script>